import { messagesRoot } from "./constants";

class GetFileData {
  constructor(apiClass) {
    this.apiClass = apiClass;
  }

  callApi = async (file) => {
    const apiRoute = messagesRoot + "GetFileData";
    return await this.apiClass.CallApiSkipErrorHandling("post", apiRoute, file);
  };
}

export default GetFileData;
